module.exports = __webpack_public_path__ + "img/filler_2.501d0a3b.svg";